import {
  DemandeResiliationCancelGQL,
  DemandeResiliationCreateGQL,
  GetDemandeResiliationEnCoursGQL,
  GetResiliationPreavisGQL,
} from '@graphql/generated';
import { computed, inject, Injectable, signal } from '@angular/core';
import { ResiliationModel } from '@lib/models/resiliation/resiliation.model';
import { DemandeResiliationModel } from '../models/demande-resiliation.model';
import { lastValueFrom } from 'rxjs';
import { ResiliationMapper } from '@lib/mappers/graphql/resiliation-mapper';

@Injectable({ providedIn: 'root' })
export class ResiliationConsultantService {
  private readonly getDemandeResiliationEnCoursGql = inject(
    GetDemandeResiliationEnCoursGQL
  );
  private readonly demandeResiliationCreateGql = inject(DemandeResiliationCreateGQL);
  private readonly demandeResiliationCancelGql = inject(DemandeResiliationCancelGQL);
  private readonly getResiliationPreavisGql = inject(GetResiliationPreavisGQL);

  private readonly _resiliation = signal<ResiliationModel | null>(null);

  public readonly resiliation = computed(() => this._resiliation());

  public async getResiliation(): Promise<ResiliationModel | null> {
    const response = await lastValueFrom(
      this.getDemandeResiliationEnCoursGql.fetch({
        variables: {},
        ...{ fetchPolicy: 'network-only' },
      })
    );

    const result = response.data!.demandeResiliationEnCoursConsultant;

    const resiliation: ResiliationModel | null = result
      ? ResiliationMapper.fromGraphql(result)
      : null;

    this._resiliation.set(resiliation);
    return resiliation;
  }

  public async getResiliationPreavis(): Promise<number> {
    const response = await lastValueFrom(this.getResiliationPreavisGql.fetch());

    return response.data!.resiliationPreavis;
  }

  public async sendDemandeResiliation(
    model: DemandeResiliationModel
  ): Promise<ResiliationModel> {
    const response = await lastValueFrom(
      this.demandeResiliationCreateGql.mutate({
        variables: {
          commentaire: model.commentaire,
          avecPreavis: model.preavis,
        },
      })
    );

    const result = response.data!.demandeResiliationSpontaneeCreate.demandeResiliation!;

    const resiliation: ResiliationModel = ResiliationMapper.fromGraphql(result);

    this._resiliation.set(resiliation);

    return resiliation;
  }

  public async cancelResiliation(): Promise<void> {
    await lastValueFrom(this.demandeResiliationCancelGql.mutate());

    this._resiliation.set(null);
  }
}
